import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog as FluentDialog, DialogSurface, DialogBody, DialogTitle, DialogContent, DialogActions, DialogTrigger } from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";
import { Button } from "./button";
/**
 * A shared dialog component wrapping Fluent UI Dialog with Babylon conventions.
 *
 * @example
 * ```tsx
 * <Dialog
 *     open={isOpen}
 *     title="Confirm Action"
 *     onDismiss={() => setIsOpen(false)}
 *     actions={[
 *         { label: "Cancel", onClick: () => setIsOpen(false) },
 *         { label: "Confirm", onClick: handleConfirm, appearance: "primary" },
 *     ]}
 * >
 *     <Text>Are you sure you want to proceed?</Text>
 * </Dialog>
 * ```
 *
 * @param props - The dialog props.
 * @returns The dialog element.
 */
export const Dialog = (props) => {
    const { open, title, children, actions, onDismiss } = props;
    return (_jsx(FluentDialog, { open: open, modalType: "modal", onOpenChange: (_, data) => {
            if (!data.open && onDismiss) {
                onDismiss();
            }
        }, children: _jsx(DialogSurface, { children: _jsxs(DialogBody, { children: [_jsx(DialogTitle, { action: onDismiss ? (_jsx(DialogTrigger, { action: "close", children: _jsx(Button, { appearance: "subtle", ariaLabel: "close", icon: DismissRegular }) })) : undefined, children: title }), _jsx(DialogContent, { children: children }), actions && actions.length > 0 && (_jsx(DialogActions, { children: actions.map((action, index) => (_jsx(Button, { appearance: action.appearance ?? "secondary", onClick: action.onClick, label: action.label }, index))) }))] }) }) }));
};
//# sourceMappingURL=dialog.js.map